export const ACTIONS = ["view", "create", "modify", "delete"];

const ROLE_ALIASES = {
  admin: "ADMIN",
  staff: "STAFF",
  dealer: "DEALER",
};

const PERMISSION_ALIASES = {
  customer_draft_view: ["customer_draft_view_all", "customer_draft_view_own", "customer_draft_view_tagged", "customer_draft_view_assigned"],
  customer_draft_view_assigned: ["customer_draft_view_tagged"],
  customer_draft_view_tagged: ["customer_draft_view_assigned"],
  customer_list_view: ["customer_list_view_all", "customer_list_view_own", "customer_list_view_tagged", "customer_list_view_assigned"],
  customer_list_view_assigned: ["customer_list_view_tagged"],
  customer_list_view_tagged: ["customer_list_view_assigned"],
  loan_view: ["loan_view_all", "loan_view_own", "loan_view_tagged", "loan_view_assigned"],
  loan_view_assigned: ["loan_view_tagged"],
  loan_view_tagged: ["loan_view_assigned"],
  loan_all_view: ["loan_all_view_all", "loan_all_view_own", "loan_all_view_tagged", "loan_all_view_assigned"],
  loan_all_view_assigned: ["loan_all_view_tagged"],
  loan_all_view_tagged: ["loan_all_view_assigned"],
  loan_draft_view: ["loan_draft_view_all", "loan_draft_view_own", "loan_draft_view_tagged", "loan_draft_view_assigned"],
  loan_draft_view_assigned: ["loan_draft_view_tagged"],
  loan_draft_view_tagged: ["loan_draft_view_assigned"],
  loan_processing_view: ["loan_processing_view_all", "loan_processing_view_own", "loan_processing_view_tagged", "loan_processing_view_assigned", "loan_processing_verification", "loan_processing_mandate"],
  loan_processing_view_assigned: ["loan_processing_view_tagged"],
  loan_processing_view_tagged: ["loan_processing_view_assigned"],
  loan_rejected_view: ["loan_rejected_view_all", "loan_rejected_view_own", "loan_rejected_view_tagged", "loan_rejected_view_assigned"],
  loan_rejected_view_assigned: ["loan_rejected_view_tagged"],
  loan_rejected_view_tagged: ["loan_rejected_view_assigned"],
  loan_closed_view: ["loan_closed_view_all", "loan_closed_view_own", "loan_closed_view_tagged", "loan_closed_view_assigned"],
  loan_closed_view_assigned: ["loan_closed_view_tagged"],
  loan_closed_view_tagged: ["loan_closed_view_assigned"],
  emi_view: ["emi_view_all", "emi_view_own", "emi_view_tagged", "emi_view_assigned"],
  emi_view_assigned: ["emi_view_tagged"],
  emi_view_tagged: ["emi_view_assigned"],
  emi_amount_modify: ["emi_modify"],
  emi_due_waive: ["emi_waive_off"],
  foreclosure_modify: ["emi_foreclose"],
  noc_modify: ["noc_issue", "noc_reissue"],
};

export const GROUPED_MODULES = [
  {
    category: "Master Data",
    modules: [
      { label: "Users", key: "master_user" },
      { label: "Roles", key: "master_role" },
      { label: "Scheme", key: "master_scheme" },
    ]
  },
  {
    category: "Customer Management",
    modules: [
      { label: "New Customer", key: "customer_create_module", actions: ["create", "change_created_by"] },
      { label: "Draft Customers", key: "customer_draft", actions: ["view_all", "view_own", "view_tagged", "modify", "delete"] },
      { label: "Customer List", key: "customer_list", actions: ["view_all", "view_own", "view_tagged", "modify", "delete", "reopen"] },
    ]
  },
  {
    category: "Loan Operations",
    modules: [
      { label: "All Loans", key: "loan_all", actions: ["view_all", "view_own", "view_tagged"] },
      { label: "Create Loan", key: "loan", actions: ["create"] },
      { label: "Draft Loans", key: "loan_draft", actions: ["view_all", "view_own", "view_tagged", "modify", "delete"] },
      { label: "Admin Approval", key: "admin_approval", actions: ["view", "modify"] },
      { label: "Processing", key: "loan_processing", actions: ["view_all", "view_own", "view_tagged", "verification", "mandate", "modify", "delete"] },
      { label: "Approved Loans", key: "loan", actions: ["view_all", "view_own", "view_tagged", "modify", "delete"] },
      { label: "Rejected Loans", key: "loan_rejected", actions: ["view_all", "view_own", "view_tagged"] },
      { label: "Closed Loans", key: "loan_closed", actions: ["view_all", "view_own", "view_tagged"] },
      { label: "NOC", key: "noc", actions: ["issue", "reissue"] },
    ]
  },
  {
    category: "EMI & Payments",
    modules: [
      { label: "EMI Collection", key: "emi", actions: ["view_all", "view_own", "view_tagged", "create", "modify", "foreclose", "pay_change_mandate_fees", "waive_off"] },
      { label: "ENach", key: "enach", actions: ["view", "create", "authorize"] },
    ]
  },
  {
    category: "Reports & Settings",
    modules: [
      { label: "Reports", key: "report", actions: ["view"] },
      { label: "Account Settings", key: "account_bank", actions: ["view", "create", "modify", "delete"] },
    ]
  }
];

export const MODULES = GROUPED_MODULES.flatMap(group => group.modules);

export const ROUTE_PERMISSIONS = [
  { pattern: /^\/$/, keys: [] },
  { pattern: /^\/users/, keys: ["master_user_view"] },
  { pattern: /^\/roles/, keys: ["master_role_view"] },
  { pattern: /^\/scheme/, keys: ["master_scheme_view"] },
  { pattern: /^\/UpdateScheme/, keys: ["master_scheme_modify"] },
  { pattern: /^\/draftcustomers/, keys: ["customer_draft_view_all", "customer_draft_view_own", "customer_draft_view_tagged", "customer_draft_view_assigned"] },
  { pattern: /^\/customers/, keys: ["customer_list_view_all", "customer_list_view_own", "customer_list_view_tagged", "customer_list_view_assigned"] },
  { pattern: /^\/createcustomers/, keys: ["customer_create_module_create"] },
  { pattern: /^\/updatecustomer/, keys: ["customer_list_modify", "customer_draft_modify"] },
  { pattern: /^\/edit-loan|^\/loan\/master-edit/, keys: ["loan_modify", "loan_draft_modify"] },
  { pattern: /^\/view-loans/, keys: ["loan_all_view_all", "loan_all_view_own", "loan_all_view_tagged", "loan_all_view_assigned"] },
  { pattern: /^\/draft-loans/, keys: ["loan_draft_view_all", "loan_draft_view_own", "loan_draft_view_tagged", "loan_draft_view_assigned"] },
  { pattern: /^\/loanverification/, keys: ["loan_processing_view_all", "loan_processing_view_own", "loan_processing_view_tagged", "loan_processing_view_assigned", "loan_processing_verification", "loan_processing_mandate"] },
  { pattern: /^\/rejected-loan/, keys: ["loan_rejected_view_all", "loan_rejected_view_own", "loan_rejected_view_tagged", "loan_rejected_view_assigned"] },
  { pattern: /^\/admin-approval/, keys: ["admin_approval_view"], roles: ["ADMIN"] },
  { pattern: /^\/viewloan|^\/admin-approved-loans/, keys: ["loan_view_all", "loan_view_own", "loan_view_tagged", "loan_view_assigned"] },
  { pattern: /^\/loan\/new/, keys: ["loan_create"] },
  { pattern: /^\/loan\/[^/]+/, keys: ["loan_create", "loan_view_all", "loan_view_own", "loan_view_tagged", "loan_view_assigned"] },
  { pattern: /^\/loan(\/?$)/, keys: ["loan_create"] },
  { pattern: /^\/emandate|^\/schedule-transaction/, keys: ["enach_create"] },
  { pattern: /^\/verify-transaction/, keys: ["enach_authorize"] },
  { pattern: /^\/emi|^\/pay-emi|^\/EmiReceiveList/, keys: ["emi_view_all", "emi_view_own", "emi_view_tagged", "emi_view_assigned", "emi_create"] },
  { pattern: /^\/forclosure/, keys: ["emi_foreclose", "foreclosure_modify"] },
  { pattern: /^\/noc-/, keys: ["loan_closed_view_all", "loan_closed_view_own", "loan_closed_view_tagged", "loan_closed_view_assigned"] },
  { pattern: /^\/reports/, keys: ["report_view"], roles: ["ADMIN"] },
  { pattern: /^\/account-settings/, keys: [] },
  { pattern: /^\/unapprovedecs|^\/approveecs/, keys: ["ecs_view"] },
];

export const getUserPermissions = (user) => (Array.isArray(user?.permissions) ? user.permissions : []);

export const getUserRole = (user) => {
  const role = String(user?.role || user?.user_role || "").trim();
  return ROLE_ALIASES[role.toLowerCase()] || role.toUpperCase();
};

export const hasRole = (user, roles = []) => {
  if (!roles.length) return true;
  const userRole = getUserRole(user);
  return roles.some((role) => getUserRole({ role }) === userRole);
};

const expandPermissionKeys = (keys) => [
  ...new Set(keys.flatMap((key) => [key, ...(PERMISSION_ALIASES[key] || [])])),
];

export const hasPermission = (user, keys = []) => {
  if (!keys.length) return true;
  if (hasRole(user, ["ADMIN"])) return true;



  const permissions = getUserPermissions(user);
  const expandedKeys = expandPermissionKeys(keys);
  return expandedKeys.some((key) => permissions.includes(key));
};

export const canAccessPath = (user, pathname) => {
  const match = ROUTE_PERMISSIONS.find((route) => route.pattern.test(pathname));
  // If no rule matches the route, allow access (don't block unknown routes)
  return match ? hasRole(user, match.roles) && hasPermission(user, match.keys) : true;
};
